import { PortableTextBlock } from '@portabletext/react';
import { useContext } from 'react';
import { A11y, Keyboard, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Container, Section } from 'components/GridV2';
import { ShortArrow } from 'components/icons';
import { ArticleCard } from 'components/rebrand/ArticleCard';
import { Button } from 'components/rebrand/Button';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { LocaleContext } from 'components/rebrand/Layout';

import { IBlogArticle } from 'typescriptDefs/pages/new-to-canada';

import { useIsMobileSize } from 'helpers';

type Props = {
  heading: PortableTextBlock | PortableTextBlock[];
  resources: IBlogArticle[];
};

const Resources = ({ heading, resources }: Props) => {
  const isMobile = useIsMobileSize();
  const locale = useContext(LocaleContext);

  return (
    <Section className="py-64 md:py-96">
      <Container className="px-32 xs:px-0">
        <div className="mb-32 text-center text-grey-450 [&_*]:mx-auto [&_h2]:mb-8 [&_h2]:text-primary-350 md:[&_h2]:mb-20 md:[&_h2]:w-[70%] [&_h2_strong]:text-primary-200 md:[&_p]:w-1/2">
          <CustomPortableText content={heading} />
        </div>
        <div className="mx-auto mb-32 flex w-fit flex-row gap-8 md:mb-64">
          <Button className="new-to-canada-articles-prev p-8">
            <ShortArrow className="h-24 w-24 rotate-180" />
          </Button>
          <Button className="new-to-canada-articles-next p-8">
            <ShortArrow className="h-24 w-24" />
          </Button>
        </div>
        <Swiper
          slidesPerView={isMobile ? 1 : 3}
          spaceBetween={30}
          slidesPerGroup={isMobile ? 1 : 3}
          modules={[A11y, Keyboard, Navigation]}
          a11y={{
            prevSlideMessage: {
              en: 'Previous slide',
              fr: 'Diapositive précédente',
            }[locale],
            nextSlideMessage: { en: 'Next slide', fr: 'Diapositive suivante' }[locale],
          }}
          keyboard
          navigation={{ enabled: true, nextEl: '.new-to-canada-articles-next', prevEl: '.new-to-canada-articles-prev' }}
        >
          {resources.map(({ img, subfolder, ...article }) => (
            <SwiperSlide key={article.slug.current}>
              <ArticleCard img={{ url: img.asset.url }} subfolder={subfolder ?? undefined} {...article} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Section>
  );
};

export default Resources;
